// align items to left if there are more than defined in attribute

function biggerIcons() {
  const iconGroup = document.querySelectorAll('[data-biggerIcons]');

  [].forEach.call(iconGroup, iconGroupContainer => {
    const items = iconGroupContainer.children;
    const count = iconGroupContainer.getAttribute('data-biggerIcons');

    if (items.length <= count) {
      iconGroupContainer.classList.add('biggerIcons');
    }
  })
}

export default biggerIcons;
